import { removeExcludedFormFields } from '@boilerplate/lib/formSchema';
import Entity from '@boilerplate/types/entity';

import DaysOffBaseOrderFormSchema from '@/_base/daysOff/DaysOffBaseOrderFormSchema';
import DaysOffBaseModel from '@/_base/daysOff/DaysOffBaseModel';
import DaysOffBaseSimpleSchema from '@/_base/daysOff/DaysOffBaseSimpleSchema';
import DaysOffBaseTableSchema from '@/_base/daysOff/DaysOffBaseTableSchema';
import DaysOffBaseInsertForm from '@/_base/daysOff/components/DaysOffBaseInsertForm';
import DaysOffBaseUpdateForm from '@/_base/daysOff/components/DaysOffBaseUpdateForm';
import DaysOffBaseTable from '@/_base/daysOff/components/DaysOffBaseTable';
import DaysOffBaseView from '@/_base/daysOff/components/DaysOffBaseView';

const DaysOffEntity: Entity<typeof DaysOffBaseModel> = {
  name: 'days_off',

  simpleSchema: DaysOffBaseSimpleSchema,

  insert: {
    simpleSchema: removeExcludedFormFields(DaysOffBaseSimpleSchema),
    orderSchema: [...DaysOffBaseOrderFormSchema],
    component: DaysOffBaseInsertForm,
  },

  update: {
    simpleSchema: removeExcludedFormFields(DaysOffBaseSimpleSchema),
    orderSchema: [...DaysOffBaseOrderFormSchema],
    component: DaysOffBaseUpdateForm,
  },

  table: {
    schema: DaysOffBaseTableSchema,
    component: DaysOffBaseTable,
  },

  view: {
    component: DaysOffBaseView,
  },

  model: DaysOffBaseModel,

  routes: {},

  settings: {
    displayField: 'id',
  },
};

export default DaysOffEntity;
